<rt-dialog-header
  [heading]="contextTranslations[dialogContext].heading"
  [subheading]="contextTranslations[dialogContext].subheading"
/>
<rt-dialog-body layout-vertical>
  <rt-group>
    @if (isMultilangEnabled && languageSwitcherItems?.length) {
      <rt-segmented-control
        [type]="'multilang-switcher'"
        [isAvailable]="true"
        [languages]="languageSwitcherItems!"
        [activeLanguage]="activeLanguage"
        [fieldsCount]="filledDefaultTranslatableFields.length"
        (segmentedButtonClicked)="setActiveLanguage($event.code)"
        margin-bottom
      />
    }
  </rt-group>
  @if (isAssignedToActiveJobs || fromJob) {
    <rt-infobox [isDismissible]="false" type="transparent" iconName="info-outline" margin-bottom>
      @if (isAssignedToActiveJobs && !fromJob) {
        <ng-container [ngTemplateOutlet]="assignedJobsMessage" />
      }
      @if (!isAssignedToActiveJobs && fromJob) {
        <ng-container [ngTemplateOutlet]="hasOnlyJobLanguagesMessage" />
      }
      @if (isAssignedToActiveJobs && fromJob) {
        <ul no-margin>
          <li><ng-container [ngTemplateOutlet]="assignedJobsMessage" /></li>
          <li><ng-container [ngTemplateOutlet]="hasOnlyJobLanguagesMessage" /></li>
        </ul>
      }
    </rt-infobox>
  }
  @if (form) {
    <form layout-full-width [formGroup]="form">
      <div formArrayName="translations">
        @for (
          c of form.controls.translations.controls;
          track trackByControl(i, c);
          let i = $index
        ) {
          <div>
            @if (c.value.langCode === activeLanguage) {
              <div [formGroupName]="i">
                <rt-form-field class="name-field" [hasLabelMargin]="false">
                  <rt-label margin-bottom-small-xx>
                    {{ 'app.locations.manage_location_dialog.form.name_label' | translate }}
                  </rt-label>
                  <rt-input
                    [maxLength]="255"
                    formControlName="name"
                    [placeholder]="
                      isDefaultLanguage
                        ? ('app.locations.manage_location_dialog.form.name_placeholder' | translate)
                        : defaultTranslationValues.name
                    "
                    [readOnly]="!isDefaultLanguage && !defaultTranslationValues.name"
                    [class.yellow]="isTranslationMarked(i, 'name')"
                  />
                </rt-form-field>
                <rt-form-field margin-top [hasLabelMargin]="false">
                  <rt-label margin-bottom-small-xx>
                    {{ 'app.locations.manage_location_dialog.form.note_label' | translate }}
                    <rt-icon-help
                      [rtTooltip]="
                        'app.locations.manage_location_dialog.form.note_tooltip' | translate
                      "
                      margin-left-small-x
                    />
                  </rt-label>
                  <rt-textarea
                    [maxLength]="500"
                    [height]="'84px'"
                    formControlName="note"
                    [placeholder]="
                      isDefaultLanguage
                        ? ('app.common.type_here' | translate) + '...'
                        : defaultTranslationValues.note
                    "
                    [readOnly]="!isDefaultLanguage && !defaultTranslationValues.note"
                    [class.yellow]="isTranslationMarked(i, 'note')"
                  />
                </rt-form-field>
                <div class="address-fields-container">
                  <rt-form-field
                    [hasLabelMargin]="false"
                    [required]="form.controls.countryCode.invalid && isDefaultLanguage"
                  >
                    <rt-label margin-bottom-small-xx>
                      {{ 'app.offer_form.country' | translate }}
                    </rt-label>
                    <rt-select
                      [formControl]="form.controls.countryCode"
                      [rtFormError]="{
                        invalidSelectedOption: 'app.common.errors.wrong_country' | translate,
                      }"
                      [hasInputTrigger]="true"
                      [groupedOptions]="groupedCountryOptions"
                      [placeholder]="'app.offer_form.country_placeholder' | translate"
                      [readOnly]="!isDefaultLanguage"
                      [isInvalid]="
                        dialogContext === LocationDialogContext.Edit &&
                        form.controls.countryCode.invalid &&
                        isDefaultLanguage
                      "
                    />
                  </rt-form-field>
                  <rt-form-field
                    [hasLabelMargin]="false"
                    [required]="
                      !fetchingRegions && isDefaultLanguage && form.controls.stateCode.invalid
                    "
                  >
                    <rt-label margin-bottom-small-xx>
                      {{ 'app.offer_form.state' | translate }}
                    </rt-label>
                    <rt-select
                      [options]="regionsOptions"
                      [placeholder]="'app.offer_form.state_placeholder' | translate"
                      [includeEmptyOption]="false"
                      [hasInputTrigger]="true"
                      [disabled]="!regionsOptions.length || fetchingRegions"
                      [formControl]="form.controls.stateCode"
                      [rtFormError]="{
                        invalidSelectedOption: 'app.common.errors.wrong_state_region' | translate,
                      }"
                      [isInvalid]="
                        dialogContext === LocationDialogContext.Edit &&
                        form.controls.stateCode.invalid &&
                        isDefaultLanguage
                      "
                      [readOnly]="!isDefaultLanguage"
                    />
                  </rt-form-field>
                  <rt-form-field [hasLabelMargin]="false">
                    <rt-label margin-bottom-small-xx>
                      {{ 'app.offer_form.city' | translate }}
                    </rt-label>
                    <rt-input
                      [placeholder]="
                        isDefaultLanguage
                          ? ('app.offer_form.city_placeholder' | translate)
                          : defaultTranslationValues.city
                      "
                      formControlName="city"
                      [maxLength]="255"
                      [readOnly]="!isDefaultLanguage && !defaultTranslationValues.city"
                      [invalid]="
                        dialogContext === LocationDialogContext.Edit &&
                        c.controls.city.invalid &&
                        isDefaultLanguage
                      "
                      [class.yellow]="isTranslationMarked(i, 'city')"
                    />
                  </rt-form-field>
                  <rt-form-field [hasLabelMargin]="false">
                    <rt-label margin-bottom-small-xx>
                      {{ 'app.offer_form.street' | translate }}
                    </rt-label>
                    <rt-input
                      [placeholder]="
                        isDefaultLanguage
                          ? ('app.offer_form.street_placeholder' | translate)
                          : defaultTranslationValues.street
                      "
                      formControlName="street"
                      [maxLength]="255"
                      [readOnly]="!isDefaultLanguage && !defaultTranslationValues.street"
                      [class.yellow]="isTranslationMarked(i, 'street')"
                    />
                  </rt-form-field>
                  <rt-form-field [hasLabelMargin]="false">
                    <rt-label margin-bottom-small-xx>
                      {{ 'app.offer_form.postal_code' | translate }}
                    </rt-label>
                    <rt-input
                      formControlName="postalCode"
                      [placeholder]="
                        isDefaultLanguage
                          ? ('app.offer_form.postal_code_placeholder' | translate)
                          : defaultTranslationValues.postalCode
                      "
                      [maxLength]="255"
                      [readOnly]="!isDefaultLanguage && !defaultTranslationValues.postalCode"
                      [class.yellow]="isTranslationMarked(i, 'postalCode')"
                    />
                  </rt-form-field>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </form>
  }
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  @if (goBackHandler) {
    <rt-button [disabled]="saving" class="optional" (click)="goBack()" variant="plain">
      <rt-icon name="arrow-back" />
      {{ 'app.common.go_back' | translate }}
    </rt-button>
  }
  <rt-button (click)="close()" variant="plain" margin-right-small>
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button [disabled]="!!form?.invalid" [loading]="saving" (click)="save()" variant="primary">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>

<ng-template #assignedJobsMessage>
  <div
    layout
    layout-align-items-center
    [attr.layout-space-between]="(assignedJobsMessage && !fromJob) || null"
  >
    {{ 'app.locations.manage_location_dialog.edit.jobs_infobox.message' | translate }}
    <rt-locations-jobs-dropdown-container [id]="this.id!">
      <rt-button variant="plain" size="small">
        {{ 'app.locations.manage_location_dialog.edit.jobs_infobox.button_label' | translate }}
      </rt-button>
    </rt-locations-jobs-dropdown-container>
  </div>
</ng-template>
<ng-template #hasOnlyJobLanguagesMessage>
  <div
    [innerHTML]="
      'app.locations.manage_location_dialog.only_job_languages_message'
        | translate: { url: locationsUrl }
    "
  ></div>
</ng-template>
